import React from "react"

import { Skeleton } from "shared/ui/skeleton/Skeleton"

import { PRODUCT_POSITION_TABLE_NAME_HEADER_ID } from "widgets/product-position-table/ProductPositionTableHeader"

import { ProductPositionTableCell } from "../../ProductPositionTableCell"
import { ProductPositionRowCellProps } from "../product-position/ProductPositionTableProductPositionRowView"

interface ProductPositionRowTitleCellProps extends ProductPositionRowCellProps {
  title: string | null | undefined
  isLoading?: boolean
}

export const ProductPositionRowTitleCell = React.memo(
  React.forwardRef(
    (
      { title, isLoading, ...rest }: ProductPositionRowTitleCellProps,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => (
      <ProductPositionTableCell
        ref={ref}
        className="product"
        aria-labelledby={PRODUCT_POSITION_TABLE_NAME_HEADER_ID}
        title={title || undefined}
        {...rest}
      >
        <div
          className="table-row-cell__content"
          data-testid="product-name-cell"
        >
          {isLoading ? <Skeleton containerClassName="flex-grow-1" /> : title}
        </div>
      </ProductPositionTableCell>
    )
  )
)
